import React from 'react';
import Waveform from 'react-audio-waveform';
import axios from 'axios';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export default class AudioWaveform extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			waveform: {},
			//low: 0,
			//high: 0,
			average: 0,
			mean: 0
		};
	}

	async componentDidMount() {
		let waveform = await axios.get(this.props.url, {withCredentials: true});
			let average = [];
			let mean = [];
			for( let i in waveform.data.data ) {
				if( waveform.data.data[i] > 0 ) average.push(waveform.data.data[i]);
				if( waveform.data.data[i] > 0 ) mean.push(waveform.data.data[i]);
			}
			let sum = Math.floor(average.reduce((partialSum, a) => partialSum + a, 0)/average.length);
			average = 20*Math.log10(sum/32767);
			mean.sort((a, b) => a - b);
			mean = mean[Math.floor(mean.length*0.9)];
			mean = 20*Math.log10(mean/32767);
			this.setState({waveform: waveform.data, average, mean});
	}

	render() {
		return (
			<>
			<div >
				<Row className="gx-0 p-2" style={{width: '90%', border: '1px solid #bbbbbb', borderRadius: 2, paddingRight: 10}}>
					<Col>
						Audio Levels
					</Col>
					<Col style={{textAlign: 'right'}}>
						Average: {this.state.average?.toFixed(2)} DB, Mean: {this.state.mean?.toFixed(2)} DB&nbsp;&nbsp;

						{this.state.average <= -12 || this.state.mean <= -12 ?
							<span className={`alert alert-${this.state.average <= -12 && this.state.mean <= -12?'danger':'warning'}`} style={{padding: 3}}>
								<OverlayTrigger
									key={'1'}
									placement={'top'}
									overlay={
										<Tooltip id={`tooltip-1`}>
											Audio Levels are {this.state.average <= -12 && this.state.mean <= -12?'very low':'low'}. Please check your audio sound levels and aim to acheive both above -12 DB.
										</Tooltip>
									}
								>
									<FontAwesomeIcon icon="triangle-exclamation" />
								</OverlayTrigger>
							</span>
						:
							<span className="alert alert-success" style={{padding: 3}}>
								<OverlayTrigger
									key={'1'}
									placement={'top'}
									overlay={
										<Tooltip id={`tooltip-1`}>
											Audio Levels are great.
										</Tooltip>
									}
								>
									<FontAwesomeIcon icon="check" />
								</OverlayTrigger>
							</span>
						}
					</Col>
				</Row>
				
			</div>
			
			<div style={{position: 'relative', width: '90%', height: this.props.height, border: '1px solid #bbbbbb', borderRadius: 2, boxShadow: '5px 5px 5px #bbbbbb', marginTop: 0}}>
				{Object.keys(this.state.waveform).length > 0 &&
					<Waveform
						barWidth={this.props.barWidth}
						peaks={this.state.waveform.data}
						height={this.props.height}
						color={this.props.color}
						progressGradientColors={this.props.progressGradientColors}
					/>
				}
			</div>
			</>
		)
	}

}


